import { ComputedRef } from 'vue'

import { PostReviewViewModel } from '@/presentation/viewmodels/reviewPost/postReviewViewModel'

export class PostReviewPresenter {
  private viewModel: PostReviewViewModel

  constructor(viewModel: PostReviewViewModel) {
    this.viewModel = viewModel
  }

  get reviewList(): ComputedRef<{ [entryId: string]: string }> {
    return this.viewModel.reviewList
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<Error | null> {
    return this.viewModel.error
  }

  setReview(entryId: string, message: string): void {
    this.viewModel.setReview(entryId, message)
  }

  async postReview(entryId: string, message: string, reviewerId: string): Promise<void> {
    if (this.isLoading.value) {
      console.log('Data sending is already in progress')
      return
    }
    await this.viewModel.postReview(entryId, message, reviewerId)
  }
}
